import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ExperimentService {
  isExperimentEnabled = new BehaviorSubject(false);
  isExperimentEnabled$ = this.isExperimentEnabled.asObservable();

  constructor() {}

  saveExperimentStatus(isExperimentEnabled: boolean) {
    this.isExperimentEnabled.next(isExperimentEnabled);
  }
}
